module.exports = __webpack_public_path__ + "img/13-01_Being Technology Savvy.ff59735a.svg";